import styled from "styled-components";

// Simple dropdown styling (like regular Dropdown component)
export const SimpleContainer = styled.div`
  display: inline-flex;
  align-items: center;
  background: transparent;
  border: none;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  min-height: 32px;
  transition: all 0.2s ease;
  opacity: ${props => props.disabled ? 0.6 : 1};
  padding: 0;
`;

export const SimpleContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  position: relative;
`;

export const SimpleText = styled.span`
  font-family: 'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #48566b;
  white-space: nowrap;
`;

export const SimpleArrow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    width: 10px;
    height: 5px;
  }
  
  svg path {
    fill: #9E9E9E;
  }
`;

// Pill dropdown - consistent padding to prevent layout jump when opening
export const PillContainer = styled.div`
  display: inline-flex;
  align-items: center;
  background: ${props => props.$isActive ? 'rgba(243, 244, 247, 1)' : 'transparent'};
  border-radius: 6px;
  padding: 6px 12px;
  // min-width: 100px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  min-height: 32px;
  transition: background 0.2s ease;
  opacity: ${props => props.disabled ? 0.6 : 1};

  &:hover {
    background: ${props => props.$isActive ? '#BBDEFB' : 'rgba(243, 244, 247, 0.5)'};
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const PillContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  position: relative;
`;

export const PillText = styled.span`
  font-family: 'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 100%;
  letter-spacing: 0%;
  color: rgba(72, 86, 107, 1);
  white-space: nowrap;
`;

export const PillArrow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
  transform: ${props => props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
  
  svg {
    width: 10px;
    height: 5px;
  }
  
  svg path {
    fill: #9E9E9E;
  }
`;

export const ClearButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-left: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  transition: all 0.2s ease;

  svg {
    width: 8px;
    height: 8px;
  }

  svg path {
    fill: #0C53BB;
    transition: fill 0.2s ease;
  }

  &:hover {
    background: rgba(25, 118, 210, 0.1);
    
    svg path {
      fill: #1565C0;
    }
  }

  &:active {
    background: rgba(25, 118, 210, 0.2);
  }
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background: #fff;
  border: 1px solid #E0E0E0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  min-width: 150px;
  max-height: 320px;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 1000;
  margin-top: 4px;
`;

export const DropdownItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  cursor: pointer;
  background: ${props => props.$isSelected ? '#F1F6FE' : 'transparent'};
  color: ${props => props.$isSelected ? '#0C53BB' : '#424242'};
  font-family: 'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 100%;
  transition: background-color 0.2s ease;

  &:hover {
    background: ${props => props.$isSelected ? '#BBDEFB' : '#F5F5F5'};
  }

  &:first-child {
    border-radius: 8px 8px 0 0;
  }

  &:last-child {
    border-radius: 0 0 8px 8px;
  }
`;

export const CheckIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;

  svg {
    width: 13px;
    height: 9px;
  }

  // svg path {
  //   fill: #9E9E9E;
  // }
`;
